export function isNullData(data) {
  if (data === undefined) { return true; }
  if (data === null) { return true; }
  if (String(data).trim().length === 0) { return true; }
  return false;
}
